import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';

export function roleGuard(...roles: string[]): CanActivateFn {
  return (_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const auth = inject(AuthService);
    const router = inject(Router);
    if (!auth.isLoggedIn()) {
      router.navigate(['/auth/pin'], { queryParams: { returnUrl: state.url } });
      return false;
    }
    if (roles.length && !roles.includes(auth.getRole()!)) {
      router.navigate(['/auth/pin']); return false;
    }
    return true;
  };
}
